import { render, staticRenderFns } from "./batchInspectionStyle.vue?vue&type=template&id=5cba0c16&scoped=true"
import script from "./batchInspectionStyle.vue?vue&type=script&lang=js"
export * from "./batchInspectionStyle.vue?vue&type=script&lang=js"
import style0 from "./batchInspectionStyle.vue?vue&type=style&index=0&id=5cba0c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba0c16",
  null
  
)

export default component.exports